export default function Gauge({ value, max, target, unit, over }) {
  const R = 130, C = 160, START = 135, SWEEP = 270;
  const pt = (deg, r = R) => { const a = (deg * Math.PI) / 180; return [C + r * Math.cos(a), C + r * Math.sin(a)]; };
  const arc = (from, to, r = R) => {
    const [x1, y1] = pt(from, r), [x2, y2] = pt(to, r);
    return `M ${x1} ${y1} A ${r} ${r} 0 ${to - from > 180 ? 1 : 0} 1 ${x2} ${y2}`;
  };
  const frac = Math.min(1, value / max);
  const color = over ? "#FF003C" : "#39FF14";
  const ticks = Array.from({ length: 11 }, (_, i) => i);
  const tDeg = target ? START + SWEEP * Math.min(1, target / max) : null;
  return (
    <svg viewBox="0 0 320 300" className="w-full max-w-[420px] mx-auto" data-testid="speedo-gauge">
      <path d={arc(START, START + SWEEP)} stroke="rgba(255,255,255,.08)" strokeWidth="18" fill="none" strokeLinecap="round" />
      {frac > 0.002 && <path d={arc(START, START + SWEEP * frac)} stroke={color} strokeWidth="18" fill="none" strokeLinecap="round"
        style={{ filter: `drop-shadow(0 0 12px ${color})`, transition: "stroke .3s" }} />}
      {ticks.map((i) => {
        const d = START + (SWEEP * i) / 10; const [x1, y1] = pt(d, 104); const [x2, y2] = pt(d, 114); const [tx, ty] = pt(d, 88);
        return <g key={i}><line x1={x1} y1={y1} x2={x2} y2={y2} stroke="rgba(255,255,255,.35)" strokeWidth="2" />
          <text x={tx} y={ty} fill="rgba(255,255,255,.45)" fontSize="11" textAnchor="middle" dominantBaseline="middle" fontFamily="JetBrains Mono">{Math.round((max * i) / 10)}</text></g>;
      })}
      {tDeg && (() => { const [x1, y1] = pt(tDeg, 116); const [x2, y2] = pt(tDeg, 146); return <line x1={x1} y1={y1} x2={x2} y2={y2} stroke="#FFE300" strokeWidth="4" strokeLinecap="round" data-testid="speedo-gauge-target" />; })()}
      <text x="160" y="168" textAnchor="middle" fill={over ? "#FF003C" : "#fff"} fontSize="84" fontWeight="900" fontFamily="Cabinet Grotesk, Outfit" data-testid="speedo-speed-value">{Math.round(value)}</text>
      <text x="160" y="200" textAnchor="middle" fill="rgba(255,255,255,.55)" fontSize="15" letterSpacing="4" fontFamily="JetBrains Mono">{unit === "kmh" ? "KM/H" : "MPH"}</text>
    </svg>
  );
}
